import React from "react";
import {Navigate, Outlet} from "react-router-dom";
import {useSelector} from "react-redux";
import {isAuthedSelector} from "modules/selectors";

export const NotAuthOnlyRoute: React.FC = () =>
	useSelector(isAuthedSelector) ? <Navigate to={"/game"} /> : <Outlet />;
